import { Component, TemplateRef } from '@angular/core';
import { PopBreakpoints } from '@my-enums/enums.enum';
import { environment } from '@my-env/environment';
import { PopupSaveAndCancel } from '@my-models/api-model';
import { UserDetails } from '@my-models/users';
import { AuthService } from '@my-services/auth.service';
import { Constants } from '@my-util/constants';
import Utility from '@my-util/utility';
import { AccordionConfig } from 'ngx-bootstrap/accordion';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';

export function getAccordionConfig(): AccordionConfig {
  return Object.assign(new AccordionConfig(), { closeOthers: true });
}

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css'],
  providers: [{ provide: AccordionConfig, useFactory: getAccordionConfig }],
})
export class HeaderComponent {
  isCollapsed: boolean = true;
  userDetails!: UserDetails;
  modalRef?: BsModalRef;
  appName = environment.appName;
  domainurls = environment.crossDomainURL;
  isproductions = environment.production;
  DASHBOARD = `${Constants.DASHBOARD_ROUTE}`;
  NEW_LAUNCH = `${Constants.NEW_LAUNCH_HOME}`;
  SUPPORT = `${Constants.SUPPORT}`;
  LOAN_ROUTER = `${Constants.LOAN}`;
  REFERRAL_ROUTER = `${Constants.REFERRAL}`;
  PAYMENT_ROUTER = `${Constants.PAYMENT}`;
  SUBSCRIPTION_ROUTER = `${Constants.SUBSCRIPTION}`;
  FOS_VISIT = `${Constants.FOS_VISIT}`;
  BROKERSACTIVITY_ROUTER = `${Constants.BROKERS_ACTIVITY}`;
  USERSUPPORT_ROUTER = `${Constants.USERS_SUPPORT}`;
  HELP_CENTER_ROUTER = `${Constants.HELP_CENTER}`;
  sideNavOpenClose: boolean = false;
  sideMenuArr: any = Utility.SIDEBAR_MENU_OBJ;
  constructor(
    private _authService: AuthService,
    private modalService: BsModalService
  ) {}
  ngOnInit() {
    this.userDetails = this._authService.getUser();
    // console.log('User Data--------->', this.userDetails);
    if (
      this.userDetails?.roleId == 5 &&
      window.location.pathname != '/login' &&
      window.location.pathname != '/dashboard' &&
      window.location.pathname != '/admin/fos-visit/create' &&
      window.location.pathname != '/admin/fos-visit/list' &&
      window.location.pathname != '/new-launches' &&
      window.location.pathname != '/new-launches/update' &&
      window.location.pathname != '/new-launches/details' &&
      window.location.pathname != '/new-launches/create'
    ) {
      // alert(window.location.pathname);
      this.Logout();
    }
  }

  postPropertyModal(templateRef: TemplateRef<any>) {
    this.modalRef = this.modalService.show(templateRef, {
      animated: true,
      class: PopBreakpoints.Small,
      backdrop: 'static',
    });
  }

  ClosePopUp(datas: PopupSaveAndCancel) {
    if (datas.Save) {
    }
    this.modalRef?.hide();
  }
  Logout() {
    this._authService.logout();
  }
}
